module.exports = function () {
    var $popupTriggers = $('.popup-modal-trigger');

    $popupTriggers.each(function (index, popupTrigger) {
        var $popupTrigger = $(popupTrigger);
        var triggerType = $popupTrigger.data('popupModalTriggerType');

        if (triggerType == 'always') {
            ICF.Modules.PopupModal.AlwaysPopup($popupTrigger);
        }
        else if (triggerType == 'time-on-page') {
            ICF.Modules.PopupModal.TimeOnPagePopup($popupTrigger);
        }
        else if (triggerType == 'time-on-site') {
            ICF.Modules.PopupModal.TimeOnSitePopup($popupTrigger);
        }
        else if (triggerType == 'scroll-distance') {
            ICF.Modules.PopupModal.ScrollDistancePopup($popupTrigger);
        }
    }); 
};